import React from 'react';

import './DesktopDropdownPlaceholder.scss';

type Props = {
    /**
     * @default 300px
     */
    height?: number;
};

const DesktopDropdownPlaceholder: React.FC<Props> = ({ height = 300 }) => {
    return <div className="desktop-dropdown-placeholder transaction-form__placeholder" style={{ height }} />;
};

export default DesktopDropdownPlaceholder;
